<template>
  <div
    v-show="allResultsModalStatus"
    class="results-pdf-append-html"
  >
    <div
      class="results-pdf-append-html__overlay"
      :class="{ ativo: allResultsModalStatus }"
      @click="fecharModal"
    />
    <div
      class="results-pdf-append-html__modal"
      :class="{ ativo: allResultsModalStatus }"
    >
      <button
        class="btn-close"
        @click="fecharModal"
      >
        <svg-loader src="/static/images/icon-close-small.svg" />
      </button>
      <iframe
        ref="iframeAllResults"
        width="100%"
        height="100vh"
      />
      <button
        class="btn btn__download"
        @click="downloadPDF"
      >
        <md-tooltip
          class="tooltip-results-export"
          md-delay="400"
          md-direction="bottom"
        >
          Exportar em PDF
        </md-tooltip>
        <svg-loader src="/static/images/icon-downloads-alt.svg" />
      </button>
      <button
        class="btn btn__print"
        @click="printPDF"
      >
        <md-tooltip
          class="tooltip-results-export"
          md-delay="400"
          md-direction="bottom"
        >
          Imprimir Laudo
        </md-tooltip>
        <svg-loader src="/static/images/icon-individual-print.svg" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AllResultsPdfInHtml',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['listHTMLForDownload', 'allResultsModalStatus'])
  },
  methods: {
    ...mapActions(['changeAllResultsModalStatus', 'exportAllResultsInPDF', 'exportAllResultToPrint']),
    fecharModal() {
      const iframe = this.$refs.iframeAllResults
      const doc = iframe.contentDocument
      doc.open()
      doc.write('')
      doc.close()
      this.changeAllResultsModalStatus(false)
    },
    carregarHTMLInicial() {
      const iframe = this.$refs.iframeAllResults
      const doc = iframe.contentDocument
      doc.open()
      doc.write(this.listHTMLForDownload)
      doc.close()
    },
    downloadPDF() {
      this.changeAllResultsModalStatus(false)
      this.exportAllResultsInPDF()
    },
    printPDF() {
      this.changeAllResultsModalStatus(false)
      this.exportAllResultToPrint()
    }
  },
  watch: {
    listHTMLForDownload(newValue) {
      this.carregarHTMLInicial()
    }
  },
  mounted() {
    this.carregarHTMLInicial()
  }
}
</script>

<style lang="scss" scoped>
.results-pdf-append-html {
  &__modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    max-width: 1000px;
    width: 90%;
    height: 100%;
    overflow: auto;
    padding: 20px 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    border-radius: 8px;
    overflow: hidden;

    iframe {
      height: 100%;
      border: none;
      margin: 40px 0;
    }

    .btn-close {
      position: absolute;
      top: 12px;
      right: 30px;
      background: transparent;
      color: #000;

      .md-icon {
        width: 16px;
        min-width: 16px;
      }
    }

    .btn {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #7f1a55;
      position: absolute;

      &__download {
        right: 62px;
        top: 15px;

        .md-icon {
          min-width: 20px;
          width: 20px;
        }
      }

      &__print {
        right: 108px;
        top: 15px;

        .md-icon {
          min-width: 28px;
          width: 28px;
        }
      }

      &:hover {
        background-color: #58123b;
      }

      .tooltip {
        z-index: 1000;
      }
    }
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .ativo {
    display: block !important;
  }
}
</style>
